module.exports = __webpack_public_path__ + "img/zl12.ceff380e.jpg";